import { useMemo } from "react";
import ButtonsHeader from "@/app/components/common/ButtonsHeader";
import { useSearchParams } from "react-router-dom";
import { defaultPaginationOptions, endpoints } from "muminsmart-utils";
import ProductListing from "@/app/components/product/ProductListing";
import { footerBg3Style } from "@/assets";

export default function WishlistPage() {
  const [searchParams] = useSearchParams();
  const sellerId = searchParams.get("id") ?? undefined;

  const fetchConfig = useMemo(
    () => ({
      endpoint: endpoints.wishlist.paginated,
      query: {
        ...defaultPaginationOptions,
        sortBy: "createdAt",
        sortOrder: "DESC",
        sellerId,
      },
      mode: "wishlist" as const,
      errorMessage: "Error fetching wishlist",
    }),
    [sellerId],
  );

  return (
    <div className="min-h-screen">
      <ButtonsHeader heading="Wishlist" />
      <div
        className="py-6 mt-4 rounded-t-3xl bg-white min-h-[calc(100vh-5rem)]"
        style={footerBg3Style}
      >
        <div className="px-4">
          <ProductListing
            fetchConfig={fetchConfig}
            className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5"
            showSearch={true}
          />
        </div>
      </div>
    </div>
  );
}
